document.addEventListener('DOMContentLoaded', function () {

  /* ---------- Scroll reveal ---------- */
  var revealEls = document.querySelectorAll('.cat-card, .product-card, .story, [data-animate]');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('in-view'); });
  }

  /* ---------- Mobile nav ---------- */
  var menuToggle = document.querySelector('[data-mobile-menu-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  var menuClose = document.querySelector('[data-mobile-menu-close]');
  var overlay = document.querySelector('[data-overlay]');

  function openMobileNav() {
    mobileNav && mobileNav.classList.add('is-open');
    overlay && overlay.classList.add('is-visible');
  }
  function closeAllPanels() {
    mobileNav && mobileNav.classList.remove('is-open');
    var drawer = document.querySelector('[data-cart-drawer]');
    drawer && drawer.classList.remove('is-open');
    overlay && overlay.classList.remove('is-visible');
  }
  menuToggle && menuToggle.addEventListener('click', openMobileNav);
  menuClose && menuClose.addEventListener('click', closeAllPanels);
  overlay && overlay.addEventListener('click', closeAllPanels);

  /* ---------- Cart drawer ---------- */
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var cartTriggers = document.querySelectorAll('[data-cart-toggle]');
  var cartClose = document.querySelector('[data-cart-close]');

  function openCart() {
    cartDrawer && cartDrawer.classList.add('is-open');
    overlay && overlay.classList.add('is-visible');
  }
  cartTriggers.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      openCart();
    });
  });
  cartClose && cartClose.addEventListener('click', closeAllPanels);

  /* ---------- AJAX Add to cart ---------- */
  document.querySelectorAll('[data-add-to-cart-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(form);
      var btn = form.querySelector('[data-atc-button]');
      var originalText = btn ? btn.textContent : '';
      if (btn) { btn.textContent = 'Adding…'; btn.disabled = true; }

      fetch('/cart/add.js', { method: 'POST', body: formData, headers: { Accept: 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function () { return refreshCart(); })
        .then(function () {
          if (btn) { btn.textContent = 'Added ✓'; }
          openCart();
          setTimeout(function () { if (btn) { btn.textContent = originalText; btn.disabled = false; } }, 1400);
        })
        .catch(function () {
          if (btn) { btn.textContent = originalText; btn.disabled = false; }
        });
    });
  });

  function refreshCart() {
    return fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        var body = document.querySelector('[data-cart-drawer-body]');
        var footer = document.querySelector('[data-cart-drawer-footer]');
        if (!body) return cart;

        if (cart.item_count === 0) {
          body.innerHTML = '<div class="cart-empty">Your bag is empty.</div>';
          if (footer) footer.style.display = 'none';
        } else {
          if (footer) footer.style.display = 'block';
          body.innerHTML = cart.items.map(function (item) {
            return '' +
              '<div class="cart-line">' +
                '<img src="' + item.image + '" alt="' + item.product_title + '">' +
                '<div class="cart-line__info">' +
                  '<a href="' + item.url + '">' + item.product_title + '</a>' +
                  '<div class="cart-line__price">' + formatMoney(item.final_price) + '</div>' +
                  '<div class="qty-row">' +
                    '<button type="button" data-change-qty="' + item.key + '" data-delta="-1">−</button>' +
                    '<span>' + item.quantity + '</span>' +
                    '<button type="button" data-change-qty="' + item.key + '" data-delta="1">+</button>' +
                  '</div>' +
                '</div>' +
              '</div>';
          }).join('');
          var subtotalEl = document.querySelector('[data-cart-subtotal]');
          if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
          body.querySelectorAll('[data-change-qty]').forEach(function (b) {
            b.addEventListener('click', function () {
              var key = b.getAttribute('data-change-qty');
              var delta = parseInt(b.getAttribute('data-delta'), 10);
              var line = cart.items.find(function (i) { return i.key === key; });
              var newQty = Math.max(0, line.quantity + delta);
              fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: key, quantity: newQty })
              }).then(refreshCart);
            });
          });
        }
        return cart;
      });
  }

  function formatMoney(cents) {
    return (window.Shopify && Shopify.currency ? Shopify.currency.active + ' ' : '$') + (cents / 100).toFixed(2);
  }

  refreshCart();

  /* ---------- Pill tab filters (homepage featured collection) ---------- */
  document.querySelectorAll('[data-pill-tabs]').forEach(function (group) {
    var buttons = group.querySelectorAll('button');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        buttons.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        var tag = btn.getAttribute('data-filter');
        var grid = document.querySelector(group.getAttribute('data-target'));
        if (!grid) return;
        grid.querySelectorAll('[data-product-tag]').forEach(function (card) {
          var tags = card.getAttribute('data-product-tag') || '';
          card.style.display = (tag === 'all' || tags.indexOf(tag) > -1) ? '' : 'none';
        });
      });
    });
  });

  /* ---------- Product gallery thumbnails ---------- */
  document.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var main = document.querySelector('[data-gallery-main]');
      var thumbs = document.querySelectorAll('[data-gallery-thumb]');
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      if (main) main.src = thumb.getAttribute('data-full');
    });
  });

  /* ---------- Product quantity selector ---------- */
  document.querySelectorAll('[data-qty-selector]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var delta = parseInt(btn.getAttribute('data-delta'), 10);
        var val = Math.max(1, (parseInt(input.value, 10) || 1) + delta);
        input.value = val;
      });
    });
  });

  /* ---------- Header shadow on scroll ---------- */
  var header = document.querySelector('[data-site-header]');
  if (header) {
    window.addEventListener('scroll', function () {
      header.style.boxShadow = window.scrollY > 12 ? '0 6px 24px rgba(60,36,21,0.08)' : 'none';
    });
  }

  /* ---------- Slideshow ---------- */
  document.querySelectorAll('[data-slideshow]').forEach(function (root) {
    var slides = root.querySelectorAll('[data-slide]');
    var dots = root.querySelectorAll('[data-slide-dot]');
    if (slides.length < 2) return;

    var current = 0;
    var timer;

    function goTo(index) {
      slides[current].classList.remove('is-active');
      dots[current] && dots[current].classList.remove('is-active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      dots[current] && dots[current].classList.add('is-active');
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    function startAutoplay() {
      clearInterval(timer);
      timer = setInterval(next, 6000);
    }

    root.querySelector('[data-slide-next]') && root.querySelector('[data-slide-next]').addEventListener('click', function () { next(); startAutoplay(); });
    root.querySelector('[data-slide-prev]') && root.querySelector('[data-slide-prev]').addEventListener('click', function () { prev(); startAutoplay(); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i); startAutoplay(); });
    });

    startAutoplay();
  });
});

/* ---------- Header search dropdown ---------- */
var searchToggle = document.querySelector('[data-search-toggle]');
var searchForm = document.querySelector('[data-search-form]');
if (searchToggle && searchForm) {
  searchToggle.addEventListener('click', function (e) {
    e.stopPropagation();
    searchForm.classList.toggle('is-open');
    if (searchForm.classList.contains('is-open')) {
      searchForm.querySelector('input[type=search]').focus();
    }
  });
  document.addEventListener('click', function (e) {
    if (!searchForm.contains(e.target) && e.target !== searchToggle) {
      searchForm.classList.remove('is-open');
    }
  });
}